import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox, Modal, Button } from '@ets/design-system';

import { toast } from 'utils/toast';
import downloadFileFromBlob from '_common/utils/downloadFileFromBlob';
import { useJobs } from '_common/components/JobsContext/JobsContext';
import { useSelector, useDispatch, useObject } from '_common/hooks';
import { setAppLoading } from 'App/redux/appSlice';
import { exportPDF, getExportPDF } from 'PDF/redux/PDFGeneralSlice';
import { closeAndResetModal } from '../ModalsSlice';

const ExportPDFModal = () => {
  const dispatch = useDispatch();
  const { addJob } = useJobs();
  const isOpen = useSelector((state) => state.modals.open.ExportPDFModal);
  const id = useSelector((state) => state.modals.ExportPDFModal.id);
  const { data } = useObject({ object_id: id, object_type: 'dopdf' });

  const [includeTasks, setIncludeTasks] = useState(true);

  const close = () => {
    dispatch(closeAndResetModal('ExportPDFModal'));
  };

  const handleExport = async () => {
    dispatch(
      setAppLoading({
        isOpen: true,
        message: 'EXPORTING_DOCUMENT',
      }),
    );
    dispatch(exportPDF({ id, options: { keep_tasks: includeTasks } }))
      .unwrap()
      .then((result) => {
        addJob(result.id, () => {
          dispatch(getExportPDF({ id }))
            .unwrap()
            .then((blob) => {
              downloadFileFromBlob(blob, `${data?.name}.pdf`);
              toast({
                variant: 'success',
                title: 'DOPDF_SUCCESSFULLY_EXPORTED',
                message: 'DOPDF_SUCCESSFULLY_EXPORTED_MESSAGE',
                messageValues: {
                  name: data?.name ?? '',
                },
                cta: {
                  children: <FormattedMessage id="DOWNLOAD_MANUALLY" />,
                  onClick: () => {
                    downloadFileFromBlob(blob, `${data?.name}.pdf`);
                  },
                },
                options: {
                  duration: Infinity,
                },
              });
            });
        });
        dispatch(setAppLoading({ isOpen: false }));
      });
    close();
  };

  return (
    <Modal width="62rem" open={!!isOpen} close={close} testId="export-pdf">
      <Modal.Header>
        <FormattedMessage id={'EXPORT'} values={{ name: data?.name }} />
      </Modal.Header>
      <Modal.Body>
        <div>
          <FormattedMessage id="DO_YOU_WANT_TO_INCLUDE_TASKS" values={{ name: data?.name }} />
          <Checkbox
            checked={includeTasks}
            onChange={() => setIncludeTasks(!includeTasks)}
            margin="2rem 0 1rem 0"
            testId="export-pdf-include-tasks"
            size="xs"
          >
            <FormattedMessage id="YES_INCLUDE_TASKS_AS_COMMENTS" />
          </Checkbox>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="standard" size="m" onClick={close} testId="export-pdf-cancel">
          <FormattedMessage id="global.cancel" />
        </Button>
        <Button
          size="m"
          variant="primary"
          style={{ margin: '0 0 0 1rem' }}
          onClick={handleExport}
          testId="export-pdf-submit"
        >
          <FormattedMessage id="global.export" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExportPDFModal;
